import {Form, Input, Segmented, Typography} from 'antd';
import type {FormInstance} from 'antd';
import React from 'react';
import {useTranslation} from '../../../hooks/useTranslation';

const {Text} = Typography;

export interface AssessmentVariableFormValues {
  name: string;
}

interface AssessmentVariableFormProps {
  form: FormInstance<AssessmentVariableFormValues>;
  type: 'group' | 'variable';
}

const AssessmentVariableForm: React.FC<AssessmentVariableFormProps> = ({form, type}) => {
  const {t} = useTranslation();
  const requiredMessage = t('messages.notFound');

  const labelKey =
    type === 'group'
      ? 'settings.content.impactAssessment.tree.form.groupName'
      : 'settings.content.impactAssessment.tree.form.variableName';

  return (
    <Form form={form} layout="vertical" preserve={false}>
      <div className="gt-ac-drawer-type-row">
        <Text className="gt-ac-drawer-type-label">
          {t('settings.content.impactAssessment.variableDrawer.typeLabel')}
        </Text>
        <Segmented
          value={type}
          disabled
          options={[
            {label: t('settings.content.impactAssessment.variableDrawer.typeGroup'), value: 'group'},
            {label: t('settings.content.impactAssessment.variableDrawer.typeVariable'), value: 'variable'},
          ]}
        />
      </div>

      <Form.Item
        name="name"
        label={t(labelKey)}
        rules={[{required: true, message: requiredMessage}]}
      >
        <Input/>
      </Form.Item>
    </Form>
  );
};

export default AssessmentVariableForm;
